import keycloak from "./keycloak";

let initPromise = null;

export const initKeycloak = () => {
  if (initPromise) {
    return initPromise;
  }

  initPromise = keycloak.init({
    onLoad: "login-required",
    checkLoginIframe: false,
    pkceMethod: "S256",
  });

  return initPromise;
};